import React, { useEffect, useState } from 'react';
import { AcessoExclusivoContext } from './AcessoExclusivoContext';
import { CategoriaSolucoesPEService } from 'core/http/service/acessosExclusivos/CategoriaSolucoesPE.service';
import keycloak from 'core/config/keycloak';
import TipoSolucoes from 'models/solucoes/TipoSolucoes';
import { useHistory } from 'react-router-dom';
import { CategoriaUsersPE } from 'core/http/service/acessosExclusivos/CategoriaUsersPE.service';
import { ProfileService } from 'core/http/service/Profile.service';
import { RoleEnum } from 'enums/RoleEnum';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import UsuarioDTO from 'models/UsuarioDTO';

export interface IAcessoExlusivoProvider {}

export const getIdSolucao = (url: string): number => {
    switch (url) {
        case 'circuito-360':
            return 1;
        case 'gestao-nota-10':
            return 2;
        case 'se-liga':
            return 3;
        case 'acelera-brasil':
            return 4;
        case 'formula-da-vitoria-portugues':
            return 5;
        case 'dialogos-socioemocionais':
            return 6;
        case 'formula-da-vitoria-matematica':
            return 7;
        // case 'realizando-escolhas':
        //     return 6;
        default:
            return -1;
    }
};

const AcessoExlusivoProvider = ({ children }: React.PropsWithChildren<IAcessoExlusivoProvider>) => {
    const serviceCategoriaSolucoes = new CategoriaSolucoesPEService();
    const usuarioLogado: UsuarioDTO = useAppSelector(state => state.authenticationReducer.usuarioLogado);
    const serviceUserCategoria = new CategoriaUsersPE();
    const servicePerfilUsuario = new ProfileService();
    const [idsMyCategorias, setIdsMyCategorias] = useState<number[]>([]);

    const [loading, setLoading] = useState<boolean>(false);
    const [getUserExistBySchool, setGetUserExistBySchool] = useState<boolean>(false);

    const history = useHistory();

    const validarSePossuiAcesso = async () => {
        const link: string = location.pathname.split('/')[2];

        const idSolucao = getIdSolucao(link);

        if (keycloak.authenticated) {
            if (keycloak.hasRealmRole(RoleEnum.Administrador)) {
                setLoading(false);
                return;
            }

            const response = await serviceCategoriaSolucoes.getSolucoesByUser();

            if (response.status === 200) {
                const solucoes: TipoSolucoes[] = response.data;

                const possui = solucoes.find(f => f.id === idSolucao);

                if (!possui && !usuarioLogado.roles.includes(RoleEnum.Administrador) && !usuarioLogado.email.includes('@ias')) {
                    history.push('/solucoes');
                } else {
                    const { data, status } = await serviceUserCategoria.listMyCategories();

                    if (status === 200) {
                        data.map((categorias: any) => {
                            setIdsMyCategorias(prevState => [...prevState, categorias.codigoCategoria]);
                        });
                    }

                    setLoading(false);
                }
            }

          
        } else {
            history.push('/solucoes');
        }
    };

    const fetchExistentSchoolUser = async () => {
        const { data, status } = await servicePerfilUsuario.getUserExistentSchoolRelations();

        if (!data && status === 200) {
            setGetUserExistBySchool(true);
        }
    };

    useEffect(() => {
        validarSePossuiAcesso();
        fetchExistentSchoolUser();
        setIdsMyCategorias([]);
    }, [location.pathname]);
    const context: AcessoExclusivoContext.IContext = {
        loading: loading,
        idsMyCategorias: idsMyCategorias,
        getUserExistBySchool: getUserExistBySchool,
        setGetUserExistBySchool: setGetUserExistBySchool,
    };

    return <AcessoExclusivoContext.Context.Provider value={context}>{children}</AcessoExclusivoContext.Context.Provider>;
};

export default AcessoExlusivoProvider;
